import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-back-button',
  templateUrl: 'back-button.template.html',
})
export class BackButtonComponent {
  @Input() text: string = this.translate.instant('admin.buttons.back');
  @Input() faIconClass: string = 'fa-regular fa-chevron-left';
  @Input() customClass: string = 'button--back';
  @Input() defaultHref: string = '/admin/profile';
  @Input() forceNavigateDefault: boolean;

  constructor(
    private navCtrl: NavController,
    private translate: TranslateService,
  ) {}

  goBack(): void {
    if (this.forceNavigateDefault) {
      this.navCtrl.navigateRoot(this.defaultHref);
      return;
    }

    const historyLength = window.history.state.navigationId;

    if (historyLength > 1) {
      this.navCtrl.back();
      return;
    }

    this.navCtrl.navigateRoot(this.defaultHref);
  }
}
